import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AiTab from "./settings/AiTab";
import Capabilities from "./Capabilities";
import AssistantTab from "./settings/AssistantTab";
import ConnectionsTab from "./settings/ConnectionsTab";
import AgentTab from "./settings/AgentTab";
import DevicesTab from "./settings/DevicesTab";
import VoiceTab from "./settings/VoiceTab";
import PermissionsTab from "./settings/PermissionsTab";
import DiagnosticsTab from "./settings/DiagnosticsTab";
import MemoryTab from "./settings/MemoryTab";
import TasksTab from "./settings/TasksTab";
import RoutinesTab from "./settings/RoutinesTab";

const TABS = [
  ["capacidades", "Capacidades", Capabilities],
  ["asistente", "Asistente", AssistantTab],
  ["conexiones", "Conexiones", ConnectionsTab],
  ["ia", "IA", AiTab], ["agente", "Agente", AgentTab], ["dispositivos", "Dispositivos", DevicesTab], ["voz", "Voz", VoiceTab],
  ["permisos", "Permisos", PermissionsTab], ["diagnostico", "Diagnóstico", DiagnosticsTab], ["memoria", "Memoria", MemoryTab],
  ["tareas", "Tareas", TasksTab], ["rutinas", "Rutinas", RoutinesTab],
];

export default function Settings() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || (params.get("ewelink") ? "dispositivos" : "ia");
  return (
    <div className="settings-page">
      <div className="settings-page-heading">
        <Link to="/" data-testid="settings-back" className="p-2 border border-cyan-500/30 text-cyan-300 hover:bg-cyan-500/10 transition-colors"><ArrowLeft className="h-4 w-4" /></Link>
        <div><p className="hud-label">PERSONALIZÁ TU ENTORNO</p><h1 className="font-hud text-3xl sm:text-4xl font-black text-cyan-300 glow-text">AJUSTES</h1></div>
      </div>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="settings-tabs">
          {TABS.map(([id, label]) => (
            <TabsTrigger key={id} value={id} data-testid={`tab-${id}`}
              className="font-ui uppercase tracking-[0.15em] text-xs data-[state=active]:bg-cyan-500/15 data-[state=active]:text-cyan-200 text-slate-400 rounded-none">{label}</TabsTrigger>
          ))}
        </TabsList>
        {TABS.map(([id, , C]) => <TabsContent key={id} value={id} className="settings-tab-content"><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
